<script lang="ts">
	import { getDiscountPercentage } from '@lib/helpers/global';
	import type { DraftBookData } from '@lib/types';
	import { twMerge } from 'tailwind-merge';

	let draftBook: DraftBookData,
		className = '';

	export { draftBook, className as class };

	$: ({ remaining_chapters, total_chapters } = draftBook);
	$: percentage = getDiscountPercentage(total_chapters, remaining_chapters);
	$: percentageState = getChaptersPercentageState(percentage);

	function getChaptersPercentageState(percentage: number) {
		let stateObj = {
			emoji: '🎉',
			style: {
				text: 'text-green-700',
				bg: 'bg-gradient-to-r from-success to-emerald-600'
			}
		};

		if (percentage >= 50) {
			stateObj = {
				emoji: '💥',
				style: {
					text: 'text-orange-700',
					bg: 'bg-gradient-to-r from-yellow-500 to-orange-500'
				}
			};
		}

		if (percentage >= 75) {
			stateObj = {
				emoji: '🌟',
				style: {
					text: 'text-amber-700',
					bg: 'bg-gradient-to-r from-orange-600 to-amber-500'
				}
			};
		}

		if (percentage >= 90) {
			stateObj = {
				emoji: '🔥',
				style: {
					text: 'text-red-700',
					bg: 'bg-gradient-to-r from-orange-500 to-error'
				}
			};
		}

		return stateObj;
	}
</script>

<div class={twMerge('space-y-2', className)}>
	{#if remaining_chapters > 0}
		<p class="text-xs font-medium {percentageState.style.text}">
			{percentageState.emoji}
			Tersisa {remaining_chapters} bab
		</p>
		<div role="progressbar" class="h-1.5 overflow-hidden rounded-lg bg-base-200">
			<div class="h-1.5 {percentageState.style.bg}" style="width: {percentage}%"></div>
		</div>
	{:else}
		<p class="text-xs font-medium text-error">Tidak ada bab tersisa 😢</p>
	{/if}
</div>
